import {
	productAttrGlobalApply,
	productAttrGlobalAssign,
	productAttrGlobalAssignConfirm,
	productAttrGlobalAssignEdit,
	productAttrGlobalAssignPaginate,
	productAttrIndividualApply
} from 'api/ProductAttrGlobalUploadApi'
import {
	ICrudApplyProductAttrFiltersSaga,
	ICrudApplyProductAttrIndividualSaga,
	ICrudProductAttrGlobalAssignConfirmSaga,
	ICrudProductAttrGlobalAssignEditSaga,
	ICrudProductAttrGlobalAssignPaginationSaga,
	ICrudProductAttrGlobalAssignSaga
} from 'models/ProductGlobalUploadInterface'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import {
	productAttrGlobalApplySuccess,
	productAttrGlobalAssignConfirmSuccess,
	productAttrGlobalAssignEditRes,
	productAttrGlobalAssignPaginateSuccess,
	productAttrGlobalAssignSuccess,
	productAttrIndividualApplySuccess
} from '../actions'
import {
	EDIT_PRODUCT_ATTR_GLOBAL_ASSIGN,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_PRODUCT_ATTR_GLOBAL_FILTERS,
	SET_PRODUCT_ATTR_INDIVIDUAL
} from '../constants/ActionsTypes'

function* productAttrGlobalApplyReq({
	payload
}: ICrudApplyProductAttrFiltersSaga): any {
	try {
		const values: any = yield call(productAttrGlobalApply, payload)
		yield put(productAttrGlobalApplySuccess(values))
	} catch (error) {}
}

function* productAttrIndividualApplyReq({
	payload
}: ICrudApplyProductAttrIndividualSaga): any {
	try {
		const values: any = yield call(productAttrIndividualApply, payload)
		yield put(productAttrIndividualApplySuccess(values))
	} catch (error) {}
}
function* productAttrGlobalAssignConfirmReq({
	payload
}: ICrudProductAttrGlobalAssignConfirmSaga): any {
	try {
		const values: any = yield call(productAttrGlobalAssignConfirm, payload)
		yield put(productAttrGlobalAssignConfirmSuccess(values))
	} catch (error) {}
}

function* productAttrGlobalAssignEditReq({
	payload
}: ICrudProductAttrGlobalAssignEditSaga): any {
	try {
		const values: any = yield call(productAttrGlobalAssignEdit, payload)
		yield put(productAttrGlobalAssignEditRes(values))
	} catch (error) {}
}
function* productAttrGlobalAssignReq({
	payload
}: ICrudProductAttrGlobalAssignSaga): any {
	try {
		const values: any = yield call(productAttrGlobalAssign, payload)
		yield put(productAttrGlobalAssignSuccess(values))
	} catch (error) {}
}
function* productAttrGlobalAssignPaginationReq({
	payload
}: ICrudProductAttrGlobalAssignPaginationSaga): any {
	try {
		const values: any = yield call(productAttrGlobalAssignPaginate, payload)
		yield put(productAttrGlobalAssignPaginateSuccess(values))
	} catch (error) {}
}
export function* productAttrGlobalApplySaga() {
	yield takeLatest(SET_PRODUCT_ATTR_GLOBAL_FILTERS, productAttrGlobalApplyReq)
}
export function* productAttrIndividualApplySaga() {
	yield takeLatest(SET_PRODUCT_ATTR_INDIVIDUAL, productAttrIndividualApplyReq)
}
export function* productAttrGlobalAssignConfirmSaga() {
	yield takeLatest(
		SET_PRODUCT_ATTR_GLOBAL_ASSIGN_CONFIRM,
		productAttrGlobalAssignConfirmReq
	)
}

export function* productAttrGlobalAssignEditSaga() {
	yield takeLatest(
		EDIT_PRODUCT_ATTR_GLOBAL_ASSIGN,
		productAttrGlobalAssignEditReq
	)
}
export function* productAttrGlobalAssignSaga() {
	yield takeLatest(SET_PRODUCT_ATTR_GLOBAL_ASSIGN, productAttrGlobalAssignReq)
}
export function* productAttrGlobalAssignPaginationSaga() {
	yield takeLatest(
		SET_PRODUCT_ATTR_GLOBAL_ASSIGN_PAGINATION,
		productAttrGlobalAssignPaginationReq
	)
}

export default function* rootSaga() {
	yield all([
		fork(productAttrGlobalApplySaga),
		fork(productAttrIndividualApplySaga),
		fork(productAttrGlobalAssignConfirmSaga),
		fork(productAttrGlobalAssignEditSaga),
		fork(productAttrGlobalAssignSaga),
		fork(productAttrGlobalAssignPaginationSaga)
	])
}
